import React, { useEffect, useState } from "react";
import { Formik } from "formik";

import { Switch } from "@headlessui/react";
import _ from "lodash";
import DatePicker from "react-datepicker";
import { useNavigate, useLocation, useParams } from "react-router-dom";

import { XMarkIcon } from "@heroicons/react/20/solid";
import eligibility from "../../../gql/eligibility";
import { useQuery } from "@apollo/client";
import CommunicationDetails from "./CommunicationDetails";
import ResponseDetailsComponent from "./response/ResponseDetailsComponent";
import ItemClassesAndBenefeciaries from "./response/ItemClassesAndBenefeciaries";
import ResponseDetailsItemsAccordian from "./response/ResponseDetailsItemsAccordian";
import JsonTable from "./response/JsonTable";
import ItemsList from "./response/ItemsList";
import gqlPreAuth from "../../../gql/preAuth";
import Encounter from "./response/Encounter";
import AccidentInfo from "./response/AccidentInfo";
import VisionPrescription from "./response/VisionPrescription";
import PreAuthSkeleton from "../../../common/PreAuthSkeleton";

import "../styles/pre-auth.css";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import { Button, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { TbEditCircle } from "react-icons/tb";
import CareTeamsTable from "./response/CareTeamsTable";
import ItemsTable from "./response/ItemsTable";
import DiagnosisTable from "./response/DiagnosisTable";
import SupportingInfoTable from "./response/SupportingInfoTable";
import ResponseDetailsComponentNew from "./response/ResponseDetailsComponentNew";
import { useTranslation } from "react-i18next";
import AppButton from "../../../shared/AppButton";
import { FaPrint } from "react-icons/fa";
import { isEditLockedStatus } from "../../../utils/transactionStatus";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    minHeight: "95vh",
    minWidth: "85%",
    maxHeight: "75vh",
    overflowY: "scroll",
    paddingTop: "0 !important",
  },
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

let subtitle;

const PreAuthDetails = ({}) => {
  const { t, i18n } = useTranslation();
  const currentDate = new Date();
  const navigate = useNavigate();
  const location = useLocation();

  const handlePrint = () => {
    window.print();
  };

  const currentItem = location.state?.currentItem
    ? location.state.currentItem
    : null;
  const { id } = useParams();

  const [enabled, setEnabled] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [myFirstName, setmyFirstName] = useState(false);
  const [showInfoItem, setshowInfoItem] = useState(false);

  const [currentTab, setCurrentTab] = useState("details");
  const handleTabClick = (tabName) => {
    setCurrentTab(tabName);
  };
  const types = [
    { id: 1, name: "HCP" },
    { id: 2, name: "Public HCP" },
  ];

  const tableHeaders = [
    { name: "Payer" },
    { name: "Expiry Date" },
    { name: "Member Card ID" },
    { name: "Policy Number" },
    { name: "Relation With Subscriber" },
  ];
  let firstName = "Payer";

  const [eligibilityResponseData, setEligibilityResponseData] = useState([
    {
      id: 1,
      InForce: "Yes",
      BenefitDate: "01/01/2023 - 31/12/2023",
      MemberId: 35444349,
      PolicyNumber: 22001814,
      Type: "Extended HealthCare",
      Status: true,
      RelationWithSubscriber: "self",
      SubscriberMemberId: "",
      Network: "0222",
      Subrogation: false,
      SiteEligibility: "eligible",
      visible: false,
    },
  ]);

  const preAuthItem = {
    payer: "XYZ",
    expiry_date: "23/3/2024",
    member_card_id: "12223",
    policy_number: "12223",
    relationShipWithSubscriber: "ssdd",
  };

  const [expanded, setExpanded] = React.useState("detail");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const {
    loading: loadingDetails,
    error: detailsError,
    data: detailsData,
    refetch: refetchDetails,
  } = useQuery(gqlPreAuth.GET_PREAUTH_TRANSACTION_DETAILS, {
    variables: {
      transactionId: id ? id : currentItem?.transaction_id,
    },
  });
  const preAuthData = detailsData?.getPreAuthTransaction?.data;
  const isEditLocked = isEditLockedStatus(preAuthData?.status);

  const {
    loading: loadingSupportingInfo,
    error: errorSupportingInfo,
    data: detailsSupportingInfo,
    refetch: refetchSupportingInfo,
  } = useQuery(gqlPreAuth.GET_PREAUTH_TRANSACTION_DETAILS_SI, {
    variables: {
      transactionId: id,
    },
    skip: expanded !== "supportinginfo" || true,
  });

  const CustomTabs = (props) => (
    <Tabs
      {...props}
      sx={{
        "& .MuiTabs-indicator": {
          backgroundColor: "#0070C2", // Customize indicator color
        },
        "& .Mui-selected": {
          color: "#0070C2", // Customize text color for selected tab
        },
        "& .MuiTabs-flexContainer": {
          "& > *": {
            color: "black", // Set default text color to black
          },
        },
      }}
    />
  );

  const tabToActive = location?.state?.tabToActive;
  useEffect(() => {
    setCurrentTab(tabToActive || "details");
  }, []);

  return (
    <>
      <style>
        {`
          @media print {
            @page {
              size: A4 landscape;
              margin: 5mm; 
            }
            .no-print {
              display: none !important;
            }
            .print-only {
              display: block !important;
            }
            body {
              background-color: white !important;
              margin: 0 !important;
              padding: 0 !important;
              width: 100% !important;
            }
            /* Reset layout containers to allow full width without forcing block on all flex elements */
            #root, 
            .h-\\[calc\\(100vh-60px\\)\\],
            .pre_auth_detail_page {
              width: 100% !important;
              max-width: 100% !important;
              padding: 0 !important;
              margin: 0 !important;
              height: auto !important;
              overflow: visible !important;
            }

            /* Ensure main wrappers don't clip content */
            .w-full.overflow-x-hidden {
              width: 100% !important;
              overflow: visible !important;
              display: block !important;
            }
            
            /* Table width fix */
            table {
              width: 100% !important;
              table-layout: auto !important;
              border-collapse: collapse !important;
            }

            /* Custom Margins for the print content */
            .pre_auth_detail_page {
               padding: 10mm !important;
            }

            /* Ensure flex backgrounds and colors are preserved */
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
          }
          .print-only {
            display: none;
          }
        `}
      </style>

      {/* Print-only heading */}
      <div
        className="print-only"
        style={{
          textAlign: "center",
          marginBottom: "30px",
          paddingBottom: "10px",
          borderBottom: "2px solid #333",
        }}
      >
        <Typography
          variant="h4"
          style={{
            fontWeight: "800",
            fontSize: "28px",
            color: "#1a202c",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          {t("Pre-Auth Details Report")}
        </Typography>
      </div>

      {loadingDetails || loadingSupportingInfo ? (
        <PreAuthSkeleton />
      ) : (
        <div class="pre_auth_detail_page relative">
          <div className="flex justify-between flex-col md:flex-row gap-2 mb-2 md:items-center items-start border-b-gray-300">
            <div class="flex !gap-2 items-start md:justify-start">
              <div
                class="cursor-pointer bg-[#0070C2] h-[24px] w-[24px] flex items-center justify-center rounded-full no-print"
                onClick={() => navigate(-1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  className={`${i18n.language === "ar" ? "rotate-180" : ""}`}
                >
                  <path
                    d="M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z"
                    fill="white"
                  ></path>
                </svg>
              </div>

              <div className="flex flex-row flex-wrap items-center gap-x-4 gap-y-1 justify-center">
                <Tooltip
                  placement="right"
                  title={t("Keep track of your Pre-Authorization details")}
                  className=""
                >
                  <span className="font-semibold text-black/70 text-[14px]">
                    <span className="text-[14px]">
                      {t("PreAuth")}:
                      <span className="font-medium text-[13px] ms-1">
                        {
                          detailsData?.getPreAuthTransaction?.data
                            ?.transaction_id
                        }
                      </span>
                    </span>
                  </span>
                </Tooltip>
                <div className="text-[13px] font-medium rounded-md min-w-[100px]">
                  <span className="font-semibold text-black/70 text-[14px]">
                    {t("Request Bundle ID")} :
                  </span>
                  <span className="!text-primary !font-[600] ml-1 text-[13px]">
                    {
                      detailsData?.getPreAuthTransaction?.data
                        ?.request_bundle_id
                    }
                  </span>
                </div>
              </div>
            </div>

            <div class="flex gap-1.5 flex-col sm:flex-row sm:w-full md:w-fit justify-end no-print">
              <AppButton
                startIcon={<FaPrint style={{ fontSize: "12px" }} />}
                label={t("Print")}
                onClick={handlePrint}
              />
              {!isEditLocked && (
                <AppButton
                  label={t("Edit Pre Auth")}
                  onClick={() => {
                    navigate(
                      `/preauth/edit/form/${detailsData?.getPreAuthTransaction?.data?.transaction_id}`,
                    );
                  }}
                  startIcon={<TbEditCircle />}
                />
              )}
              <AppButton
                onClick={() =>
                  detailsData?.getPreAuthTransaction?.data?.type === "oral"
                    ? navigate("/claims/dcaf", {
                        state: { item: detailsData?.getPreAuthTransaction?.data },
                      })
                    : navigate("/claims/ucaf", {
                        state: { item: detailsData?.getPreAuthTransaction?.data },
                      })
                }
                startIcon={<DescriptionOutlinedIcon sx={{ fontSize: 16 }} />}
              >
                {detailsData?.getPreAuthTransaction?.data?.type === "oral"
                  ? t("DCAF")
                  : t("UCAF")}
              </AppButton>
              {detailsData?.getPreAuthTransaction?.data?.is_followup_req &&
              detailsData?.getPreAuthTransaction?.data?.status ===
                "rejected" ? (
                <AppButton
                  label={t("Follow Up")}
                  startIcon={<AddIcon />}
                  onClick={() => {
                    navigate(
                      `/preauth/edit/form/${
                        detailsData?.getPreAuthTransaction?.data?.transaction_id
                      }/${"follow-up"}`,
                    );
                  }}
                  className="!border-primary !text-primary hover:!bg-primary/10"
                />
              ) : !detailsData?.getPreAuthTransaction?.data?.is_followup_req ? (
                <AppButton
                  label={t("Follow Up")}
                  startIcon={<AddIcon />}
                  variant="outlined"
                  onClick={() => {
                    navigate(
                      `/preauth/edit/form/${
                        detailsData?.getPreAuthTransaction?.data?.transaction_id
                      }/${"follow-up"}`,
                    );
                  }}
                  className="!border-primary !text-primary hover:!bg-primary/10"
                />
              ) : null}
            </div>
          </div>

          <div className="my-2 no-print">
            <ul className="grid grid-flow-col text-center text-gray-500 bg-gray-100 rounded-lg p-1 shadow-inner overflow-x-auto">
              <li>
                <a
                  className={`flex justify-center py-1 px-2 cursor-pointer hover:text-primary text-[13px] ${
                    currentTab === "details"
                      ? "bg-[#0070C2] rounded-lg !text-white"
                      : ""
                  }`}
                  onClick={() => handleTabClick("details")}
                >
                  {t("Details")}
                </a>
              </li>
              <li>
                <a
                  className={`flex justify-center py-1 px-2 cursor-pointer hover:text-primary text-[13px] ${
                    currentTab === "communications"
                      ? "bg-[#0070C2] rounded-lg !text-white"
                      : ""
                  }`}
                  onClick={() => handleTabClick("communications")}
                >
                  {t("Communications")}
                </a>
              </li>
            </ul>
          </div>
          {currentTab == "details" && (
            <>
              {detailsData?.getPreAuthTransaction?.data?.errors?.map(
                (el, index) => {
                  return (
                    <div className="sm:col-span-6 mb-2">
                      <div class="px-3 py-6 text-sm text-red-800 rounded-lg bg-red-50 dark:text-red-400">
                        <span class="font-medium">
                          {t("Error")} {el?.error_code} :{" "}
                        </span>
                        {el?.error_message}
                      </div>
                    </div>
                  );
                },
              )}
              <div className="">
                <div>
                  <div className="flex"></div>
                  <div className="border border-slate-200 rounded-lg overflow-hidden">
                    <ResponseDetailsComponentNew
                      item={detailsData?.getPreAuthTransaction?.data}
                    />
                  </div>
                </div>
              </div>
              <Box className="my-2">
                <Typography
                  className="flex gap-2 !font-bold mb-1 !text-[16px]"
                  variant="h6"
                  sx={{ width: "50%", flexShrink: 0 }}
                >
                  {t("Items")}
                </Typography>
                <ItemsTable data={detailsData} />
              </Box>
              <Box className="my-2">
                <Typography
                  className="flex gap-2 !font-bold mb-1 !text-[16px]"
                  variant="h6"
                  sx={{ width: "50%", flexShrink: 0 }}
                >
                  {t("Diagnosis")}
                </Typography>
                <DiagnosisTable
                  data={detailsData?.getPreAuthTransaction}
                  loading={loadingDetails}
                />
              </Box>
              <Box className="my-2 ">
                <Typography
                  className="flex gap-2 !font-bold mb-1 !text-[18px]"
                  variant="h6"
                  sx={{ width: "50%", flexShrink: 0 }}
                >
                  {t("Care Teams")}
                </Typography>
                <CareTeamsTable
                  data={detailsData?.getPreAuthTransaction}
                  loading={loadingDetails}
                />
              </Box>
              <Box className="my-2">
                <Typography
                  className="flex gap-2 !font-bold mb-1 !text-[18px]"
                  variant="h6"
                  sx={{ width: "50%", flexShrink: 0 }}
                >
                  {t("Supporting Info")}
                </Typography>
                <SupportingInfoTable
                  data={detailsData?.getPreAuthTransaction}
                  loading={loadingDetails}
                />
              </Box>
              <Encounter
                item={detailsData?.getPreAuthTransaction?.data?.encounter}
              />
              <VisionPrescription
                item={detailsData?.getPreAuthTransaction?.data}
              />
              <AccidentInfo item={detailsData?.getPreAuthTransaction?.data} />
            </>
          )}
          {currentTab == "communications" && (
            <>
              <CommunicationDetails
                currentItem={currentItem}
                item={detailsData}
              />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default PreAuthDetails;
